export const updateItem = (inputs, config) => {
    let errors = [];
    if (!inputs) {
        errors.push('inputs');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return fetch(`${process.env.REACT_APP_URL}/Item/UpdateItem/${inputs?.id}`, {
            method: 'PUT',
            ...config,
            body: JSON.stringify(inputs)
        })
    }
}

export const fetchItem = (itemConfig) => {
    let errors = [];
    if (!itemConfig) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return fetch(`${process.env.REACT_APP_URL}/Item/FetchItems`, {
            method: 'POST',
            ...itemConfig,
            body: ""
        })
    }
}
